import { render, staticRenderFns } from "./ServiceTypeLabel.vue?vue&type=template&id=6db39ff2&scoped=true"
import script from "./ServiceTypeLabel.vue?vue&type=script&lang=ts"
export * from "./ServiceTypeLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db39ff2",
  null
  
)

export default component.exports